import { getSystemAnnounces, getSystemSetting } from "@/apis/service.api";
import { getCookie, setCookie } from "../helpers/io/cookie";
import { domainQuery } from "../helpers/hostname.helper";
import type { ResponseGetSystemAnnounce, ResponseGetSystemSetting } from "@/../@types/fun-to-wait";

export default function useSystem() {
    const readSystemAnnounces = async (): Promise<ResponseGetSystemAnnounce[]> =>
        await getSystemAnnounces(domainQuery());
    const readSystemSetting = async (): Promise<ResponseGetSystemSetting> => await getSystemSetting(domainQuery());

    const popupAnnouncesStatus = (): number | undefined => {
        const cookie = getCookie("vacan/funtowait/popup-announces");
        if (!cookie) return undefined;
        return parseInt(cookie);
    };

    const setPopupAnnouncesUnixtime = (accessUnixtime: number) =>
        setCookie("vacan/funtowait/popup-announces", accessUnixtime.toString(), 999);

    return { readSystemAnnounces, readSystemSetting, popupAnnouncesStatus, setPopupAnnouncesUnixtime };
}
